import { render } from "./WhySogdoItsHowWorksComp.vue?vue&type=template&id=0d2feca0&scoped=true"
import script from "./WhySogdoItsHowWorksComp.vue?vue&type=script&lang=js"
export * from "./WhySogdoItsHowWorksComp.vue?vue&type=script&lang=js"

import "./WhySogdoItsHowWorksComp.vue?vue&type=style&index=0&id=0d2feca0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2feca0"]])

export default __exports__